document.addEventListener('DOMContentLoaded', function() {
  var collapsibles = document.getElementsByClassName('collapsible');
  for (var i = 0; i < collapsibles.length; i++) {
    collapsibles[i].addEventListener('click', function() {
      this.classList.toggle('active');
      var content = this.nextElementSibling;
      content.classList.toggle('open');
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
      } else {
        content.style.maxHeight = (content.scrollHeight + 20) + 'px';
      }
    });
  }
});
